import React from 'react'
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const LocationMap = ({ lat, lng, address }) => {

if (!lat || !lng) return <p>No location available</p>;

  return (
    <>
    <div className="h-48 w-full rounded-xl overflow-hidden shadow">
      <MapContainer center={[lat, lng]} zoom={16} className="h-full w-full">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        <Marker position={[lat, lng]}>
          <Popup>{address}</Popup>
        </Marker>
      </MapContainer>
    </div>
    </>
  )
}

export default LocationMap